exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".block-left[data-v-73aa0b86] .v-btn__content {\n  justify-content: left;\n}\n", ""]);

